import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AngularFireDatabase } from "angularfire2/database";
/**
 * Generated class for the CustomerNotificationsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-customer-notifications',
  templateUrl: 'customer-notifications.html',
})
export class CustomerNotificationsPage {
  chekId: any;
  restId: any;
  items: any = [];
  loading: boolean = true;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public af: AngularFireDatabase
  ) {
    this.loading = true;
    this.chekId = this.navParams.get('chekId');
    this.restId = this.navParams.get('restId');
    this.af.list('Orders/' + this.restId, ref => ref.orderByChild('chekId').equalTo(this.chekId)).valueChanges().subscribe(data => {
      this.items = data;
      console.log(this.items);
      this.loading = false;
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CustomerNotificationsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/customer-notifications/customer-notifications.ts